<div class="row">
    <div class="col-md-12">
        <br>
        <div class="minititulo">Mi videoconsulta</div>
        <div class="titulo m-0">Fila de Espera</div>
    </div>
</div>
<br>

<!-- Sección de Lugar en la fila y Tiempo de Espera -->
<div class="row text-center justify-content-center" style="    width: 90%;
    margin: auto;">
    <!-- Lugar en la Fila -->
    <div class="col-lg-4 col-md-4 col-sm-12 p-2 m-0" style="display: flex;
        justify-content: flex-end;">
        <div class="card p-3 m-0" *ngIf="isLoading" style="min-height: 60px;">
                    <div class="loader">
                        <div class="loader__figure" style="border: 0 solid #2BABB7;"></div>
                        <p class="loader__label"></p>
                    </div>

                </div>
        <div *ngIf="!isLoading" class="card p-3 m-0"
            [ngStyle]="{ 'background-color': isLoading ? '#DCDCDC' : '#D5FFF7' }"
            style="border-radius: 15px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); width: 100%;">
            <div class="row" style="height: 100%;">
              
                <div class="col-12 d-flex align-items-center" style=" gap: 5px;">
                    <div class="col-3 p-0"
                        style="display: flex; justify-content: center; align-items: center; height: 100%;">
                        <mat-icon style="    color: #000;
                        font-size: -webkit-xxx-large;
                        width: fit-content;
                        height: fit-content;">person_outline</mat-icon>
                    </div>
                    <div class="col-6 p-0" style="gap: 10px !important;;
                    display: flex ;flex-direction: column;">
                        <div style="height: 40%;
                        display: flex;     justify-content: center;
                        align-items: flex-end;">

                            <p style="font-size: 16px;
                    font-family: 'Mulish';
                    margin: 0;
                    color: black;
                    font-weight: 700; ">
                                <b>Lugar </b>
                                en la fila:
                            </p>
                        </div>

                    </div>
                    <div class="col-3 p-0"
                        style="display: flex; justify-content: center; align-items: center; height: 100%;">
                        <h4 style="font-weight: bold; margin: 10px 0 5px 0; font-family: 'Mulish';    font-size: 24px;">
                            {{ isLoading ? 0 : tiempoEspera.data.posicion }}
                        </h4>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- Tiempo de Espera -->
    <div class="col-lg-4 col-md-4 col-sm-12 p-2 m-0" style="display: flex;
        justify-content: flex-end;"> 
        <div class="card p-3 m-0" *ngIf="isLoading" style="min-height: 60px;">
                    <div class="loader">
                        <div class="loader__figure" style="border: 0 solid #2BABB7;"></div>
                        <p class="loader__label"></p>
                    </div>

                </div>       
        <div *ngIf="!isLoading" class="card p-3 m-0"
            [ngStyle]="{ 'background-color': isLoading ? '#DCDCDC' : '#D5FFF7' }"
            style="border-radius: 15px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); width: 100%;">
            <div class="row " style="height: 100%;">
                <!-- Título -->

                <!-- Ícono y Datos -->
                <div class="col-12 d-flex align-items-center" style=" gap: 5px;">
                    <div class="col-3 p-0"
                        style="display: flex; justify-content: center; align-items: center; height: 100%;">
                        <mat-icon style="    color: #000;
                        font-size: -webkit-xxx-large;
                        width: fit-content;
                        height: fit-content;">schedule</mat-icon>
                    </div>
                    <div class="col-6 p-0" style="gap: 10px !important;;
                    display: flex ;flex-direction: column;">
                        <div style="height: 40%;
                        display: flex;     justify-content: center;
                        align-items: flex-end;">

                            <p style="font-size: 16px;
                    font-family: 'Mulish';
                    margin: 0;
                    color: black;
                    font-weight: 700; ">
                                <b>Minutos </b>
                                de espera:
                            </p>
                        </div>

                    </div>
                    <div class="col-3 p-0"
                        style="display: flex; justify-content: center; align-items: center; height: 100%;">
                        <h4 style="font-weight: bold; margin: 10px 0 5px 0; font-family: 'Mulish'; font-size: 24px;">
                              {{ isLoading ? 0 : (redondearTiempo(tiempoEspera.data.tiempoEspera) > 60 ? '+60' : redondearTiempo(tiempoEspera.data.tiempoEspera)) }}
                        </h4>

                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="col-lg-4 col-md-4 col-sm-12 p-2 m-0">
            <div class="row cardInfo" style="display: flex; flex-direction: row;
      padding: 10px; margin: 0; padding-left: 0;">
        <div class="col-md-2 col-2" style="display: flex; justify-content: center; align-items: center;">
          <mat-icon style="color: #171994; font-size: 30px;">info</mat-icon>
        </div>
        <div class="col-md-10 col-10" style="align-self: center;">
          <p class="infoStyleText m-0" style="text-align: justify; font-size: 14px;"><b>Puedes salir de esta pantalla o de la plataforma sin perder tu turno.</b></p>
          <p class="infoStyleText m-0" style="text-align: justify; font-size: 12px;">Te avisaremos apenas un médico esté disponible para tu atención.</p>
        </div>
      </div>

    </div>
</div>

<!-- Mensaje de espera -->
<div class="row text-center justify-content-center mt-4">
    <div class="col-10">
        <p class="mensaje-espera">
            Gracias por confiar en AlmaMedis.
            <br>
            Tu salud es nuestra prioridad y pronto serás atendido por uno de nuestros profesionales médicos.
        </p>
    </div>
</div>

<!-- Imagen ilustrativa -->
<div class="row text-center justify-content-center">
  <div class="col-md-8 col-sm-12">

    <!-- Mobile / Tablets (xs, sm): muestra imagen alternativa -->
    <img
      src="assets/images/Online_Doctor.gif"
      class="img-fluid img-espera d-block d-md-none"
      alt="Fila de espera (móvil)"
      style="padding: 15px; background-color: #D5FFF7;"
    />

    <!-- Desktop (md en adelante): muestra el gif actual -->
    <img
      src="assets/images/Diseño-sin-título.gif"
      class="img-fluid img-espera d-none d-md-block"
      alt="Fila de espera"
      style="padding: 15px; background-color: #D5FFF7;"
    />

  </div>
</div>


<!-- Mensaje de turno y botón para salir de la fila -->
<div class="row text-center justify-content-center mt-3">
    <div class="col-10">
        <p class="mensaje-turno">
            {{this.isLoading ? '' : this.mensajeTurno}}
        </p>

        <div class="row" style="display: flex; align-items: center;">
            <div class="col-md-8 col-sm-12 d-flex align-items-center justify-content-between p-3"
                style="background-color: #eaf4ff; border-radius: 12px; box-shadow: 0 2px 6px rgba(0,0,0,0.1);">
            <div class="row" style="display: flex;align-items: center;">
                <div class="col-md-2 col-sm-2">
                    <mat-icon style="color: #171994; font-size: 28px; margin-right: 10px;">calendar_month</mat-icon>
                </div>
                <div class="col-md-5 col-sm-2" style="font-family: 'Mulish'; margin-bottom: 10px; padding: 0;">
                    <span >Si prefieres, también <b style="font-weight: 700;">puedes agendar una hora</b> con un médico sin perder tu lugar en la fila.</span>
                </div>
                <div class="col-md-5 col-sm-12 p-0">
                    <!-- Botón -->
                    <button (click)="reservaHora()" type="button" class="btn btn-primary px-4" style="border-radius: 20px; font-weight: bold; background-color: #316AD8; font-size: 14px;
    padding: 10px;">
                        Reservar ahora
                    </button>

                </div>
            </div>
        </div>

          <div class="col-md-4 col-sm-12">
              <!-- Botón para abrir el modal -->
              <button type="button" class="btn  salir-fila" style="font-family: 'Mulish';" (click)="mostrarModal('salir')">
                  <mat-icon>directions_walk</mat-icon> Salir de la fila
              </button>
          </div>
        </div>

        <!-- Modal de Confirmación -->


    </div>
</div>

<!-- Sección de avisos importantes -->
<div class="row text-center justify-content-center mt-4">
    <div class="col-lg-5 col-md-6 col-sm-10 aviso m-3">
        <p class="aviso-texto">
            Recuerda que debes encender tu cámara y tu micrófono, antes de iniciar tu consulta de telemedicina.
        </p>
    </div>
    <div class="col-lg-5 col-md-6 col-sm-10 aviso m-3">
        <p class="aviso-texto">
            Si tienes algún problema técnico, o el profesional médico no se presenta, debes comunicarte con nuestra Mesa
            de Ayuda.
        </p>
        <p class="aviso-contacto">800 248 030</p>
    </div>
    <div class="row cardInfo" style="display: flex; flex-direction: row; width: 100%;
        padding: 10px;">
        <div class="col-md-1 col-2" style="display: flex; justify-content: center; align-items: center;">
            <mat-icon style="color: #171994; font-size: 30px;">info</mat-icon>
        </div>
        <div class="col-md-11 col-10" style="align-self: center; padding-left: 0;">
            <p class="infoStyleText" style="text-align: justify;">
                El tiempo de espera mostrado es referencial y puede variar. Esta estimación se calcula considerando el
                tiempo promedio de atención, la disponibilidad de profesionales y la cantidad de personas en la fila.
                AlmaMedis no garantiza que el tiempo estimado de espera coincida con el tiempo real de atención.
            </p>
        </div>

    </div>
</div>


<!-- Backdrop Oscuro (Evita clics fuera del modal) -->
<div class="modal-backdrop" *ngIf="modalActual === 'salir'" (click)="$event.stopPropagation()"></div>

<div class="modal-backdrop-common" *ngIf="modalActual === 'salir'" (click)="cerrarModal()">
    <div class="modal-common-content" (click)="$event.stopPropagation()">
        <h2 class="modal-title">¿Deseas salir de la fila de atención inmediata?</h2>
<p class="modal-reason">{{ cancelMsg1 }}</p>
        <p class="modal-reason">{{ cancelMsg2 }}</p>
        <p class="modal-reason2">Selecciona un motivo para continuar con la anulación:</p>

        <form [formGroup]="salirFilaForm">
            <div class="form-group">
                <select class="form-control" id="razonSelect" formControlName="reason">
                    <option value="" disabled selected>Selecciona un motivo</option>
                    <option *ngFor="let razon of cancelReason" [value]="razon.id_reason">
                        {{ razon.reason_name }}
                    </option>
                </select>
            </div>
        </form>
        
        <div *ngIf="salirFilaForm.value.reason == 1" class="col-md-12 col-sm-12 d-flex align-items-center justify-content-between p-3"
                style="background-color: #eaf4ff; border-radius: 12px; box-shadow: 0 2px 6px rgba(0,0,0,0.1);">
            <div class="row" style="display: flex
            ;
                align-items: center;">
                <div class="col-md-2 col-sm-2">
                    <mat-icon style="color: #171994; font-size: 28px; margin-right: 10px;">info</mat-icon>
                </div>
                <div class="col-md-5 col-sm-2" style="font-family: 'Mulish'; margin-bottom: 10px; padding: 0;">
                    <span >Si prefieres, puedes <b style="font-weight: 700;">reservar una hora con </b>uno de nuestros médicos.</span>
                </div>
                <div class="col-md-5 col-sm-12 p-0">
                    <!-- Botón -->
                    <button (click)="reservaHora()" type="button" class="btn btn-primary px-4" style="border-radius: 20px; font-weight: 600; background-color: #316AD8; font-size: 14px;
    padding: 10px;">
                        Agendar ahora
                    </button>

                </div>
            </div>
        </div>

        <div class="buttons-box row">
            <div class="col">
                <button mat-button class="btn-secondary" (click)="cerrarModal()">
                    <p class="m-0" style="font-weight: 600;">Volver</p>
                </button>
            </div>
            <div class="col">
                <button mat-raised-button class="btn-primary" style="border: 2px solid #2F7586 !important;"
                    color="primary" (click)="abrirConfirmacionSinDevolucion()" [disabled]="salirFilaForm.invalid">
                    <p class="m-0" style="font-weight: 600;">Aceptar</p>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal 2: Confirmación final -->
<div class="modal-backdrop-common" *ngIf="modalActual === 'confirmarSinDevolucion'" (click)="cerrarModal()">
    <div class="modal-common-content" (click)="$event.stopPropagation()">
        <h2 class="modal-title">Confirmación de salida</h2>
        <p class="modal-reason">
            Vas a salir de la fila de espera de atención inmediata. Al salir, perderás tu lugar y deberás ingresar nuevamente si deseas ser atendido.
        </p>

        <div class="buttons-box row">
            <div class="col">
                <button mat-button class="btn-secondary" (click)="cerrarModal()">
                    <p class="m-0" style="font-weight: 600;">Cancelar</p>
                </button>
            </div>
            <div class="col">
                <button mat-raised-button class="btn-primary" style="border: 2px solid #2F7586 !important;"
                    (click)="salirDeFila()" [disabled]="isLoadingExitFila">
                    <p class="m-0" style="font-weight: 600;">Aceptar</p>
                </button>
            </div>
        </div>
    </div>
</div>